import { TicketService } from '../../services/ticket.service'
import SelectEmployee from '@/components/SelectEmployee.vue'

import _ from 'lodash'
export default {
  components: { SelectEmployee },
  data() {
    return {
      selectedTicket: [],
      callioConfig: JSON.parse(localStorage.getItem('callioConfig')) ?? {},
    }
  },
  methods: {
    canNew(status, userMain, userExtra) {
      return (
        ['PENDING'].includes(status) &&
        (this.canAccessMx('CNPS_TICKET_NEW') || this.dataUser.userId === userMain?.userId)
      )
    },
    canCancel(status, userMain, userExtra) {
      return (
        ['NEW', 'PROCESSING'].includes(status) &&
        (this.canAccessMx('CNPS_TICKET_CANCEL') || this.dataUser.userId === userMain?.userId)
      )
    },
    canComplete(status, userMain, userExtra) {
      return (
        ['PROCESSING'].includes(status) &&
        (this.canAccessMx('CNPS_TICKET_APPROVE_REJECT') ||
          this.dataUser.userId === userMain?.userId)
      )
    },
    canPending(status, userMain, userExtra) {
      return (
        ['NEW', 'PROCESSING'].includes(status) &&
        (this.canAccessMx('CNPS_TICKET_PENDING') || this.dataUser.userId === userMain?.userId)
      )
    },
    canProcessing(status, isManualUpdate, userMain, userExtra) {
      return (
        isManualUpdate === true &&
        ['NEW'].includes(status) &&
        (this.canAccessMx('CNPS_TICKET_PROCESSING') ||
          userMain?.userId ||
          userExtra?.userId === this.dataUser.userId)
      )
    },
    canStart(status = null, isManualUpdate, userMain, userExtra) {
      return (
        isManualUpdate === false &&
        (this.canAccessMx('CNPS_TICKET_START_FLOW') ||
          userMain?.userId ||
          userExtra?.userId === this.dataUser.userId) &&
        ['NEW', null].includes(status)
      )
    },
    canEdit(status, userMain, isManualUpdate, userExtra) {
      return (
        ['NEW'].includes(status) ||
        (['PROCESSING'].includes(status) &&
          isManualUpdate == true &&
          (this.canAccessMx('CNPS_TICKET_EDIT') ||
            userMain?.userId ||
            userExtra?.userId === this.dataUser.userId))
      )
    },
    canInitAppendix(status, userMain, userExtra) {
      return (
        ['PROCESSING'].includes(status) &&
        (this.canAccessMx('CALL_SUCCESS_SIGN_CONTRACT') ||
          userMain?.userId ||
          userExtra?.userId === this.dataUser.userId)
      )
    },
    async processTicketWithWorkflow(id) {
      try {
        this.showLoading = true
        const res = await TicketService.getActivityId({ id })
        if (res.success === true) {
          window.open(res.data.linkActivities, 'blank')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.showLoading = false
      }
    },
    async processTicketWithCallio(merchantInfo, ticketId, typeCode) {
      this.$store.commit('callio/SET_TMP_CURRENT_USER_CALL', {
        ticketId: ticketId,
        customerId: merchantInfo.customerId,
        customerName: merchantInfo.customerName,
        mobile: merchantInfo.mobile,
        email: merchantInfo.email,
        city: merchantInfo.city,
        district: merchantInfo.district,
        typeTicket: typeCode,
      })
      this.$store.commit('callio/SET_MODAL', true)
      this.$store.commit('callio/SET_MODAL_MINI', false)
    },
    async newItem(item) {
      const flag = await this.approveMx(
        `Bạn có chắc chắn muốn quay về mới tạo cho ticket ${item.ticketCode} không?`
      )
      if (flag === true) {
        this.showLoading = true
        const res = await TicketService.new({
          ticketId: item.ticketId,
        })
        this.showLoading = false
        if (res.success === true) {
          this.showSuccessMx(`Quay về mới tạo cho ticket ${item.ticketCode} thành công`)
          this.fetchData()
        } else this.showFailMx(res.message)
      }
    },
    async cancelItem(item) {
      try {
        this.showLoading = true
        const res = await TicketService.cancel(item)
        this.showLoading = false
        if (res.success === true) {
          this.showSuccessMx(`Huỷ ticket thành công (id: ${item.ticketId})`)
          this.fetchData()
          this.$bvModal.hide('change-status-ticket')
          this.showChangeStatusTicket = false
        } else this.showFailMx(res.message)
      } catch (error) {
        this.showFailMx(error.message)
      } finally {
        this.showLoading = false
      }
    },
    async completeItem(item) {
      try {
        this.showLoading = true
        const res = await TicketService.complete(item)
        if (res.success === true) {
          this.showSuccessMx(`Ticket đã được hoàn thành (id: ${item.ticketId})`)
          this.fetchData()
          this.$bvModal.hide('change-status-ticket')
          this.showChangeStatusTicket = false
        } else this.showFailMx(res.message)
      } catch (error) {
        this.showFailMx(error.message)
      } finally {
        this.showLoading = false
      }
    },
    async pendingItem(item) {
      try {
        this.showLoading = true
        const res = await TicketService.pending(item)
        if (res.success === true) {
          this.showSuccessMx(`Tạm hoãn ticket thành công (id: ${item.ticketId})`)
          this.fetchData()
          this.$bvModal.hide('change-status-ticket')
          this.showChangeStatusTicket = false
        } else this.showFailMx(res.message)
      } catch (error) {
        this.showFailMx(error.message)
      } finally {
        this.showLoading = false
      }
    },
    async processingItem(item) {
      const flag = await this.approveMx(
        `Bạn có chắc chắn bắt đầu xử lý ticket ${item.ticketCode} không?`
      )
      if (flag === true) {
        this.showLoading = true
        const res = await TicketService.processing({
          ticketId: item.ticketId,
        })
        this.showLoading = false
        if (res.success === true) {
          this.showSuccessMx(`Bắt đầu xử lý ticket ${item.ticketCode} thành công`)
          this.fetchData()
        } else this.showFailMx(res.message)
      }
    },
    async startItem() {
      try {
        const ticket = this.selectedTicket
        const flag = await this.approveMx(
          `Bạn có chắc chắn bắt đầu xử lý với ${this.selectedTicket.length} ticket trên không?`
        )
        if (this.selectedTicket.length === 1) this.selectedTicket = []
        if (flag === true) {
          this.showLoading = true
          const res = await TicketService.start({
            ticketIds: ticket,
          })
          this.showLoading = false
          if (res.success === true) {
            this.showMsgOk(res.data)
            this.fetchData()
          } else this.showFailMx(res.message)
        }
      } catch (error) {
        this.showFailMx(error.message)
      } finally {
        this.showLoading = false
      }
    },
    showMsgOk(data) {
      const h = this.$createElement
      // Using HTML string
      const titleVNode = h('div', {
        domProps: { innerHTML: 'Thông báo' },
      })
      // More complex structure
      const messageVNode = h('div', { class: ['text-center'] }, [
        h('p', { class: ['text-center'] }, [
          'Số ticket đã chuyển trạng thái đang xử lý: ',
          h('b', data.successIds.length),
          ' ticket',
        ]),
        h('p', { class: ['text-center'] }, [
          'Số ticket chưa chuyển trạng thái đang xử lý:',
          h('b', data.failedIds.length),
          ' ticket',
        ]),
      ])
      this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        centered: true,
      })
    },
    showMsgOkAssgine(data) {
      const h = this.$createElement
      // Using HTML string
      const titleVNode = h('div', {
        domProps: { innerHTML: 'Thông báo' },
      })
      // More complex structure
      const messageVNode = h('div', { class: ['text-center'] }, [
        h('p', { class: ['text-center'] }, [
          'Số ticket đã gán người thành công: ',
          h('b', data.successList.length),
          ' ticket',
        ]),
        h('p', { class: ['text-center'] }, [
          'Số ticket chưa gán người thành công:',
          h('b', data.failList.length),
          ' ticket',
        ]),
      ])
      this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        centered: true,
      })
    },
    async onSelectSale(sale) {
      const params = {
        assigneeId: sale.userId,
        ticketId: this.selectedTicket[0],
      }
      if (this.selectedTicket.length === 1) this.selectedTicket = []
      try {
        this.showLoading = true
        const res = await TicketService.assign(params)
        if (res.success === true) {
          this.showSuccessMx(`Ticket trên đã được gán cho nhân viên`)
          this.fetchData()
        } else this.showFailMx(res.message)
      } catch (error) {
      } finally {
        this.showLoading = false
      }
    },
    editItem(id) {
      this.$router.push({
        path: `/ticket/edit/${id}`,
      })
    },
    create(url) {
      this.$router.push({ path: `/${url}/create` })
    },
    edit(url, id) {
      this.$router.push({ path: `/${url}/edit/${id}` })
    },
    canCreateAndEdit(role) {
      return this.canAccessMx(`${role}`)
    },
    config(id) {
      this.$router.push({ path: `/ticket-category/config-workflow/${id}` })
    },
    async changStatus(item, type) {
      this.typeCode = item.typeCode
      this.ticketId = item.ticketId
      this.checkResult = type
      this.showChangeStatusTicket = true
      this.$nextTick(s => this.$bvModal.show('change-status-ticket'))
    },
    userFollowers(item) {
      return item?.length > 0
    },
  },
}
